module.exports = __webpack_public_path__ + "static/media/ie.7d4d2d90.svg";